import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import Loader from 'components/layout/Loader';
import Data from 'components/Data';
import Entity from 'components/Entity';

import FormInput from 'components/forms/FormInput';
import FormRichEditor from 'components/forms/FormRichEditor';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormErrors from 'components/forms/FormErrors';

import { entityMetaMapping } from 'js/constants';

class MessageForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      entityLoaded: false,
      entityChanged: false,
    };

    this.entity = new Entity();
    // if we get user data from the outside, we can pass it on to our data entity
    this.entity.setData(props.data || { bccCreator: true });
    if (props.meta[entityMetaMapping.message] !== undefined && !props.meta[entityMetaMapping.message].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.message);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  changeEntity = (entity, callback = null) => {
    this.setState({ entity, entityChanged: true }, callback);
  };

  updateEntity = (propertyName, value) => {
    const newEntity = { ...this.state.entity.updateValue(propertyName, value, []) };

    this.changeEntity(newEntity);
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { shown, meta, sendHint = {} } = this.props;
    const { entityLoaded } = this.state;

    if (shown && entityLoaded && !prevProps.shown) {
      this.refs.subject.catchFocus();
    }

    if (shown && entityLoaded && !prevState.entityLoaded) {
      this.refs.subject.catchFocus();
    }

    if (
      meta[entityMetaMapping.message] !== undefined &&
      !meta[entityMetaMapping.message].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.message);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
    if (entityLoaded && sendHint.type !== '' && this.entity.getBccCreator()) {
      this.updateEntity('bccCreator', false);
    }
  };

  componentDidMount = () => {
    // this.refs.editor.catchFocus()
  };

  formSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState(
      prevState => ({ entity: prevState.entity.validate() }),
      () => {
        const { formContext, onSubmit } = this.props;
        const { entity } = this.state;

        if (entity.isValid) {
          onSubmit({
            ...entity.processedData,
            contexts: formContext ? [formContext] : [],
          });
        }
      }
    );
  };

  templateSelected = (fieldName, data) => {
    this.refs.subject.setValue(data.subject);
    this.refs.content.setValue(data.content);
  };

  render() {
    const {
      intl: { messages },
      formStatus,
      user,
      sendHint = {},
    } = this.props;
    const { entity, entityChanged, entityLoaded } = this.state;

    return (
      <Row>
        <Data dataName="message" /> {/* fetch meta data */}
        <Col xs={12}>
          <FormErrors formStatus={formStatus} />

          {!entityLoaded ? (
            <Loader />
          ) : (
            <form method="post" onSubmit={this.formSubmit}>
              <div class="panel panel-transparent">
                <div class="form-group-attached m-b-15">
                  <FormAutocomplete
                    name="template"
                    label={messages.load_message_from_template}
                    autocompleteType="emailTemplate"
                    onChange={this.templateSelected}
                    returnValueObject
                  />
                </div>
                <div class="form-group-attached">
                  <FormInput
                    ref="subject"
                    name="subject"
                    label={messages.subject}
                    meta={entity.getSubjectMetaInformation()}
                    validation={entity.getSubjectValidationResult()}
                    onChange={this.updateEntity}
                    disabled={formStatus.pending}
                  />
                  <FormRichEditor
                    ref="content"
                    name="content"
                    label={messages.content}
                    meta={entity.getContentMetaInformation()}
                    validation={entity.getContentValidationResult()}
                    onChange={this.updateEntity}
                    disabled={formStatus.pending}
                  />
                  {sendHint.type === '' && !!user.profile.email && (
                    <div class="form-group form-group-default">
                      <FormSwitchery
                        name="bccCreator"
                        label={messages.send_copy_to_me + ' (' + user.profile.email + ')'}
                        value
                        checked={entity.getBccCreator()}
                        onChange={this.updateEntity}
                        disabled={formStatus.pending}
                      />
                    </div>
                  )}
                </div>

                {sendHint.message && <div class="m-t-15">{sendHint.message}</div>}
                <div class="text-right m-t-15">
                  <Button
                    bsSize="lg"
                    disabled={formStatus.pending}
                    type="submit"
                    bsStyle={entityChanged ? 'primary' : 'default'}
                  >
                    <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'paper-plane')} />{' '}
                    {messages.send}
                  </Button>
                </div>
              </div>
            </form>
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    meta: state.entityMeta,
    user: state.login.user,
    formContext: state.formStatus.context,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(MessageForm)));
